import supabase from '../supabaseClient';

export const FOOTAGE_LAYOUT_STITCH = 'stitch';
export const FULL_MATCH_STITCH_SLOT = 'full_match';

export function sanitizeS3MatchKey(raw, fallback = 'uploads') {
  const cleaned = String(raw || '')
    .trim()
    .replace(/[^A-Za-z0-9_.-]/g, '_');
  return cleaned || fallback;
}

export function matchFootagePartKey(matchKey, index) {
  const n = String(Number(index) + 1).padStart(4, '0');
  return `full_match_mp4/${sanitizeS3MatchKey(matchKey)}/parts/${n}.mp4`;
}

export function matchFootageStitchedKey(matchKey) {
  return `full_match_mp4/${sanitizeS3MatchKey(matchKey)}/stitched.mp4`;
}

export function isFootageStitchPending(gameOrMeta) {
  const meta = gameOrMeta?.extra_players_metadata != null
    ? (typeof gameOrMeta.extra_players_metadata === 'string'
      ? (() => {
        try {
          return JSON.parse(gameOrMeta.extra_players_metadata) || {};
        } catch {
          return {};
        }
      })()
      : gameOrMeta.extra_players_metadata)
    : (gameOrMeta || {});
  return meta?.footage_stitch_pending === true || meta?.footage_stitch_pending === 'true';
}

/**
 * Ask the AWS stitch worker to concat uploaded parts into one full-match MP4.
 * Analysis uses that file the same way as a normal single upload.
 */
export async function triggerFootageStitch({
  matchId,
  matchIds = [],
  s3MatchKey,
  uploadToken = null,
  delayMs = 3000,
} = {}) {
  const ids = Array.from(new Set([matchId, ...(matchIds || [])].filter(Boolean)));
  if (ids.length === 0) {
    throw new Error('No match to stitch footage for.');
  }

  const { data, error } = await supabase.functions.invoke('trigger-highlight-stitch', {
    body: {
      match_id: ids[0],
      match_ids: ids,
      s3_match_key: sanitizeS3MatchKey(s3MatchKey || ids[0]),
      slot: FULL_MATCH_STITCH_SLOT,
      action: 'stitch_footage',
      source: 'footage_upload',
      delay_ms: delayMs,
      upload_token: uploadToken || null,
    },
  });

  if (error) {
    throw new Error(error.message || 'Failed to start clip stitch');
  }
  return data;
}
